import { useQuery } from "@tanstack/react-query";
import type { SolutionPipelinePayload } from "@/api/solution-pipeline";
import { solutionPipelineKeys } from "@/lib/query";

export type {
  PipelineDealSlice,
  SolutionPipelinePayload,
  SolutionPipelinePeriod,
} from "@/api/solution-pipeline";

async function fetchSolutionPipeline(solutionId: string): Promise<SolutionPipelinePayload> {
  const res = await fetch(`/api/dashboard/solutions/${solutionId}/pipeline`);
  if (!res.ok) throw new Error("solution pipeline unavailable");
  return res.json();
}

/**
 * Forward pipeline ($ per future period) for one Solution — the "Pipeline"
 * section of the Forecast tab. Sourced from the studio-authored Gateway view.
 */
export function useSolutionPipeline(solutionId: string) {
  return useQuery<SolutionPipelinePayload>({
    queryKey: solutionPipelineKeys.detail(solutionId),
    queryFn: () => fetchSolutionPipeline(solutionId),
    enabled: Boolean(solutionId),
    staleTime: 5 * 60 * 1000,
  });
}
